<template>
    <div>
        <van-nav-bar :title="$t('results.result_details')" fixed left-arrow @click-left="onClickLeft" class="nav-bar">
            <template #left>
                <van-icon name="arrow-left" size="22" color="#333" />
            </template>
            <template #right>
                <div style="font-size: 14px;padding-right: 20px;" @click="show=true">{{ $t('results.filter') }}</div>
            </template>
        </van-nav-bar>
        <van-action-sheet class="actionPop" v-model="show" :actions="actions" @select="onSelect" />
        <div class="content">
            <div class="openTime">
                <div class="logo"><img src="/img/renzheng.png" alt="">
                </div>
                <div class="msg">
                    <div class="name">
                        {{ $t('results.certification_window') }}
                    </div>
                    <div class="period">
                        {{ now_expect }} {{ $t('results.round') }}
                    </div>
                </div>
                <div class="time">
                    <van-count-down class="count_down" style="color: rgb(172, 98, 204);" format="HH:mm:ss" :time="time"
                        @finish="getLotteryInfo()" />
                </div>
            </div>
            <div class="btnGroup">
                <div class="btnBox"></div>
                <div class="btnBox"></div>
            </div>

            <div class="list">
                <div class="vux-flexbox-item" style="margin-top: 8px;" v-for="item in lottery_list" :key="item.id">
                    <div class="itemBox">
                        <div class="msg">
                            <div class="heads">
                                <div class="period">
                                    {{ item.expect }} {{ $t('results.round') }}
                                </div>
                                <div class="time">
                                    {{ item.create_time }}
                                </div>
                            </div>
                            {{ (item.opencode[0] +
                                item.opencode[1] +
                                item.opencode[2]) >= 11 && (item.opencode[0] + item.opencode[1] + item.opencode[2]) &lt;= 18 ? rose :lily
                            }}
                            {{
                                (item.opencode[0] + item.opencode[1] + item.opencode[2]) % 2 === 0
                                    ? balloon
                                    : fireworks
                            }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="footBtn">
                <a @click="$router.push('/GameRecord')" class="goOrder">{{ $t('results.view_winning_records') }}</a>
                <a @click="$router.push('/lotteryHall')" class="goBet">{{ $t('results.go_bet') }}</a>
            </div>
        </div>
    </div>
</template>
<script>
import dayjs from 'dayjs';
import { getLangKind } from '@/common/locale';
export default {
    data() {
        return {
            actions:[
                { name: this.$t('results.recent_20_rounds'), value: 20 },
                { name: this.$t('results.recent_30_rounds'), value: 30 },
                { name: this.$t('results.recent_50_rounds'), value: 50 },
                { name: this.$t('results.recent_100_rounds'), value: 100 },
                { name: this.$t('results.recent_300_rounds'), value: 300 }
            ],
            show:false,
            lottery_list: [],
            time: 0,
            now_expect: '',
            rose: '',
            lily: '',
            balloon: "",
            fireworks: "",
            limit:20,
        }
    },
    created() {
        // 根据当前语言设置玩法名称（与 lottery/index.vue 保持一致的写法与取值；zh 覆盖简繁）
        const currentLang = getLangKind();
        if (currentLang == 'zh') {
            this.rose = '火箭';
            this.lily = '飛機';
            this.balloon = '跑車';
            this.fireworks = '游艇';
        } else if (currentLang == 'en') {
            this.rose = 'Rose';
            this.lily = 'Lily';
            this.balloon = 'Balloon';
            this.fireworks = 'Fireworks';
        } else if (currentLang == 'ja') {
            this.rose = 'ロケット';
            this.lily = 'ハート';
            this.balloon = 'バラ';
            this.fireworks = 'ヨット';
        } else {
            this.rose = '장미';
            this.lily = '백합';
            this.balloon = '풍선';
            this.fireworks = '불꽃놀이';
        }
        this.getLotteryInfo()
        this.getLotteryList()
    },
    methods: {
        onSelect(item){
            this.show=false
            this.limit=item.value
            this.getLotteryList()
        },
        getLotteryList() {
            this.$http({
                method: "get",
                data: { key: 5,limit:this.limit },
                url: "lottery_get_one_list",
            }).then((res) => {
                if (res.code === 200) {
                    res.data.forEach(v=>{
                        v.create_time=dayjs(v.create_time*1000).format('YYYY-MM-DD HH:mm:ss')
                    })
                    this.lottery_list = res.data
                } else if (res.code === 401) {
                    this.$toast(res.msg);
                }
            });
        },
        getLotteryInfo() {
            this.$http({
                method: "get",
                data: { key: 5 },
                url: "lottery_get_info",
            }).then((res) => {
                if (res.code === 200) {
                    this.time = res.data.second * 1000;
                    this.now_expect = res.data.now_expect
                } else if (res.code === 401) {
                    this.$toast(res.msg);
                }
            });
        },
        onClickLeft() {
            this.$router.go(-1)
        },
    }
}
</script>
<style lang="less" scoped>
/deep/ .van-tabs__nav {
    background: initial;
}

/deep/ .van-nav-bar__title {
    color: #333 !important;
}

.van-nav-bar {
    background: white;
    border-bottom-width: 0;
}
.actionPop{
    /deep/.van-action-sheet__name{
        font-size: 32px;
        line-height: 88px;
    }
}
.content {
    padding: 120px 0;
    background: #f2f2f2;
}

.openTime {
    box-sizing: content-box;
    padding: 30px 40px;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    height: 120px;

    .logo {
        -webkit-flex-shrink: 0;
        flex-shrink: 0;

        img {
            width: 120px;
            height: 120px;
        }
    }

    .msg {
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        flex: 1;
        margin-left: 24px;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        flex-direction: column;
        -webkit-justify-content: space-around;
        justify-content: space-around;

        .name {
            font-size: 36px;
        }

        .period {
            color: #666666;
            font-size: 30px;
        }
    }

    .time {
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-flex-shrink: 0;
        flex-shrink: 0;
        -webkit-box-align: end;
        -webkit-align-items: flex-end;
        align-items: flex-end;

        .count_down {
            line-height: 40px;
            color: #ff4d67;
            font-size: 34px;
            line-height: 50px;
            border-width: 0;
            padding: 0;
            border-radius: 0;
            margin-top: 4px;
            float: inherit;
        }
    }
}

.btnBox:last-child {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: reverse;
    -webkit-flex-direction: row-reverse;
    flex-direction: row-reverse;
}

.btnGroup {
    padding: 0 40px 20px;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;

    .btnBox {
        width: 50%;
        -webkit-flex-shrink: 0;
        flex-shrink: 0;
    }
}

.list {
    .vux-flexbox-item {
        -webkit-box-flex: 1;
        flex: 1;
        -webkit-flex: 1;
        min-width: 40px;
        width: 0%;
        background: #fff;
        padding: 30px 0;
        margin-top: 10px !important;
    }

    .vux-flexbox-item:first-child {
        margin-left: 0 !important;
        margin-top: 0 !important;
    }

    >.vux-flexbox-item {
        width: 100%;
    }

    .itemBox {
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;

        .msg {
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            -webkit-flex-direction: column;
            flex-direction: column;
            -webkit-box-flex: 1;
            -webkit-flex-grow: 1;
            flex-grow: 1;
            padding: 0 40px;

            .heads {
                display: flex;
                -webkit-box-pack: justify;
                -webkit-justify-content: space-between;
                justify-content: space-between;
                height: 34px;
                line-height: 34px;

                .period {
                    font-size: 34px;
                }

                .time {
                    font-size: 28px;
                    color: #a9a9a9;
                }
            }
        }
    }
}

.footBtn {
    position: fixed;
    bottom: 0;
    left: 0;
    height: 88px;
    line-height: 88px;
    text-align: center;
    width: 100%;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;

    a {
        display: block;
        color: #ffffff;
        width: 50%;
    }

    .goBet {
        background: #ff7a8a;
    }

    .goOrder {
        background: #FF5C74;
    }
}
</style>